import React from 'react';
import img_1 from "../../../assets/img/Collection/img_1.jpg";
import img_2 from "../../../assets/img/Collection/img_2.jpg";
import img_3 from "../../../assets/img/Collection/img_3.jpg";
import img_4 from "../../../assets/img/Collection/img_4.jpg";
import './style.css';

function Collection() {
    return (
        <div className="d-flex justify-content-between pt-5">
            <div className="w-50 me-3">
                <div className="banner_img">
                    <img src={img_1} alt="img" width="100%" />
                </div>

                <div className="banner_img mt-4">
                    <img src={img_2} alt="img" width="100%" />
                </div>
            </div>

            <div className="w-50 ms-3">
                <div className="banner_img">
                    <img src={img_3} alt="img" width="100%" />
                </div>

                <div className="banner_img mt-4">
                    <img src={img_4} alt="img" width="100%" />
                </div>
            </div>
        </div>
    );
}

export default Collection;